import { NegotiableFieldRequired, Order, SettlementVenue } from 'api'

export const getNegotiatedValue = <T>(field: NegotiableFieldRequired<T> | null | undefined) => {
  return field ? (field.modified ? field.modifiedValue : field.negotiated) : null
}

export const resetNegotiationInstruction = (order: Order, newSettlementVenue: SettlementVenue | null) => {
  return {
    ...order,
    negotiationInstruction: {
      ...order.negotiationInstruction,
      settlementVenue: newSettlementVenue,
      clearingType: null,
      clearingHouseId: null,
      sponsorId: null
    }
  }
}
